// current_status types
export const CURRENT_STATUS_PENDING = 1
export const CURRENT_STATUS_RUNNING = 2
export const CURRENT_STATUS_INVALID = 3

// send on types
export const SEND_ON_BIZ_DAYS = 0
export const SEND_ON_ANY_DAYS = 1
